import { render, staticRenderFns } from "./CollaborateurTasks.vue?vue&type=template&id=f0017b32&"
import script from "./CollaborateurTasks.vue?vue&type=script&lang=js&"
export * from "./CollaborateurTasks.vue?vue&type=script&lang=js&"
import style0 from "./CollaborateurTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports